'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartController = function () {
    function CartController($ionicLoading, $ionicPopup, $rootScope, $state, ApiPicklist, ApiSelections, ApiUser, localStorageService, MessageBox, stripe, $ionicScrollDelegate) {
        _classCallCheck(this, CartController);

        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.ApiPicklist = ApiPicklist;
        this.ApiSelections = ApiSelections;
        this.ApiUser = ApiUser;
        this.localStorageService = localStorageService;
        this.MessageBox = MessageBox;
        this.stripe = stripe;
        this.$ionicScrollDelegate = $ionicScrollDelegate;

        this.cartItems = [];
        this.payment = {};
        this.payment.bankAccount = {};
        this.payment.card = {};
        this.payment.selectionsToPurchase = {};
        this.step = 1;
        this.sum = 0;
        this.user = {};
        this.step = 1;
        this.isPurchase = true;
    }

    _createClass(CartController, [{
        key: 'showLoading',
        value: function showLoading() {
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
        }
    }, {
        key: 'init',
        value: function init() {
            var _this = this;

            this.showLoading();
            this.step = 1;

            var cart = this.localStorageService.get('cart');

            if (!cart) {
                this.$ionicLoading.hide();
                return;
            }

            this.cartItems = JSON.parse(cart);

            this.verifyPriceOfEachCartItem();

            // get personal data for invoice
            this.ApiUser.getUser().then(function (res) {
                if (typeof res != 'undefined') {
                    _this.user = res;
                    _this.$ionicLoading.hide();
                } else {
                    _this.$ionicLoading.hide();
                }
            });

            this.yearValues = this.ApiPicklist.createPicker(new Date().getFullYear(), 15);
            this.monthValues = this.ApiPicklist.createPicker(1, 12);

            this.ApiPicklist.getAdvindaCountries().then(function (countries) {
                _this.contactCountries = countries.data.sort();
            });

            this.ApiPicklist.getEuropeanUnionCountries().then(function (countries) {
                _this.europeanCountries = countries.data.sort();
            });
        }
    }, {
        key: 'verifyPriceOfEachCartItem',
        value: function verifyPriceOfEachCartItem() {
            var _this2 = this;

            var cartItemsWithAddlInfoRemoved = this.removeAdditionalInfoFromCartItems();
            this.ApiSelections.verifyPrices(cartItemsWithAddlInfoRemoved).then(function (res) {
                var requireCartUpdate = false;
                res.forEach(function (item) {
                    var cartItem = _this2.cartItems.find(function (cartItem) {
                        return cartItem.numberOfUsers === item.numberOfUsers && cartItem.selectionId === item.selectionId;
                    });
                    if (cartItem && cartItem.cost != item.unitPrice) {
                        requireCartUpdate = true;
                        cartItem.cost = item.unitPrice;
                    }
                });

                if (requireCartUpdate) {
                    _this2.localStorageService.set('cart', JSON.stringify(_this2.cartItems));
                }
                _this2.calculateSum();
            });
        }
    }, {
        key: 'removeAdditionalInfoFromCartItems',
        value: function removeAdditionalInfoFromCartItems() {
            var cartItemsWithAddlInfoRemoved = angular.copy(this.cartItems);
            cartItemsWithAddlInfoRemoved.map(function (c) {
                delete c.aumThreshold;
                delete c.totalNumberOfAccounts;
            });
            return cartItemsWithAddlInfoRemoved;
        }
    }, {
        key: 'calculateSum',
        value: function calculateSum() {
            for (var i = 0; i < this.cartItems.length; i++) {
                this.sum += this.cartItems[i].cost;
            }
        }
    }, {
        key: 'removeCartItem',
        value: function removeCartItem(cart) {
            this.sum -= cart.cost;
            this.cartItems.splice(this.cartItems.indexOf(cart), 1);
            this.localStorageService.set('cart', JSON.stringify(this.cartItems));
            this.$rootScope.$broadcast('cartChanged', { count: this.cartItems.length });
        }
    }, {
        key: 'previousStep',
        value: function previousStep() {
            this.$ionicScrollDelegate.scrollTop();
            this.step -= 1;
        }
    }, {
        key: 'nextStep',
        value: function nextStep() {
            this.$ionicScrollDelegate.scrollTop();
            this.step += 1;
        }
    }, {
        key: 'saveUser',
        value: function saveUser() {
            var _this3 = this;

            this.showLoading();
            this.ApiUser.changeUser(this.user, this.isPurchase).then(function (res) {
                _this3.$ionicLoading.hide();
                if (res != undefined) {
                    _this3.nextStep();
                }
            });
        }
    }, {
        key: 'stripePurchase',
        value: function stripePurchase(invoiceActive) {
            var _this4 = this;

            this.showLoading();
            // this.payment.selectionsToPurchase = JSON.parse(this.localStorageService.get('cart'));
            this.payment.selectionsToPurchase = this.getCartItemsForPurchase();
            this.ApiUser.changeUser(this.user, this.isPurchase).then(function (res) {
                if (res && !invoiceActive) {
                    _this4.stripe.card.createToken(_this4.payment.card).then(function (response) {
                        var payment = angular.copy(_this4.payment);
                        payment.card = void 0;
                        payment.token = response.id;

                        _this4.ApiSelections.purchaseByCC(payment).then(function (res) {
                            if (typeof res != 'undefined') {
                                _this4.$ionicPopup.alert({
                                    title: '<b>Purchase successful</b>',
                                    template: 'You have successfully purchased the package. Now you are able to assign licenses to your team members.',
                                    okType: 'button-picton-blue'
                                });
                                _this4.localStorageService.remove('cart');
                                _this4.$rootScope.$broadcast('cartChanged', { count: 0 });
                                _this4.$state.go('selections');
                            }
                        });
                    }).catch(function (err) {
                        _this4.$ionicLoading.hide();
                        _this4.handleStripeError(err);
                    });
                } else if (res && invoiceActive) {

                    _this4.purchaseByInvoice();
                }
            });
        }
    }, {
        key: 'purchaseByInvoice',
        value: function purchaseByInvoice() {
            var _this5 = this;

            if (!this.payment || !this.payment.selectionsToPurchase) return;
            // this.payment.selectionsToPurchase = JSON.parse(this.localStorageService.get('cart'));
            this.payment.selectionsToPurchase = this.getCartItemsForPurchase();
            this.showLoading();
            var packages = this.payment.selectionsToPurchase.map(function (s) {
                return {
                    selectionId: s.selectionId,
                    numberOfUsers: s.numberOfUsers,
                    numberOfLicenses: s.numberOfLicenses
                };
            });

            this.ApiSelections.purchaseByInvoice(packages).then(function (response) {
                _this5.localStorageService.remove('cart');
                _this5.$rootScope.$broadcast('cartChanged', { count: 0 });
                _this5.$state.go('selections');
                _this5.$ionicLoading.hide();
                _this5.MessageBox.showSuccessMessage('LISENSE', 'PURCHASE');
            }, function (error) {
                this.$ionicLoading.hide();
            });
        }
    }, {
        key: 'handleStripeError',
        value: function handleStripeError(err) {
            if (err.type && /^Stripe/.test(err.type)) {
                this.$ionicPopup.alert({
                    title: '<b>Purchase issue</b>',
                    template: err.message,
                    okType: 'button-picton-blue'
                });
            } else {
                this.$ionicPopup.alert({
                    title: '<b>Purchase issue</b>',
                    template: err.message,
                    okType: 'button-picton-blue'
                });
            }
        }
    }, {
        key: 'buy',
        value: function buy() {
            var self = this;
            var cartItems = this.getCartItemsForPurchase();
            self.showLoading();
            for (var i = 0; i < cartItems.length; i++) {
                self.ApiSelections.purchaseByInvoice(cartItems[i]);
            }
        }
    }, {
        key: 'getCartItemsForPurchase',
        value: function getCartItemsForPurchase() {
            var self = this;
            var cart = JSON.parse(this.localStorageService.get('cart'));
            return cart.map(function (selection) {
                return {
                    'selectionId': selection.selectionId,
                    'numberOfUsers': selection.numberOfUsers,
                    'numberOfLicenses': selection.numberOfLicenses
                };
            });
        }
    }, {
        key: 'getCartItemsForDisplay',
        value: function getCartItemsForDisplay() {
            var self = this;
            var cart = JSON.parse(this.localStorageService.get('cart'));
            return cart.map(function (selection) {
                return {
                    'selectionsToPurchase': [{
                        'selectionId': selection.selectionId,
                        'numberOfUsers': selection.numberOfUsers,
                        'numberOfLicenses': selection.numberOfLicenses,
                        'totalNumberOfAccounts': selection.totalNumberOfAccounts,
                        'aumThreshold': selection.aumThreshold
                    }]
                };
            });
        }
    }, {
        key: 'loadTaxRate',
        value: function loadTaxRate() {
            var _this6 = this;

            this.showLoading();
            this.ApiUser.getTaxRate().then(function (res) {
                _this6.taxRate = res;
                _this6.taxAmount = _this6.sum * _this6.taxRate;
                _this6.totalAmount = _this6.sum + _this6.taxAmount;
                _this6.$ionicLoading.hide();
            });
        }
    }]);

    return CartController;
}();

exports.default = CartController;


/** WEBPACK FOOTER **
 ** ./src/app/components/cart/cart.controller.js
 **/